import React, { useEffect, useState } from 'react';
import './Certifications.css';
import {
  FaExternalLinkAlt,
  FaUniversity,
  FaGraduationCap,
  FaEthereum,
  FaPython,
  FaChartBar,
} from 'react-icons/fa';
import { SiVercel } from 'react-icons/si';
import { Certification } from '../types';
import { getCertifications } from '../data/localDataService';

const iconMap: { [key: string]: JSX.Element } = {
  SiVercel: <SiVercel />,
  FaUniversity: <FaUniversity />,
  FaGraduationCap: <FaGraduationCap />,
  FaEthereum: <FaEthereum />,
  FaPython: <FaPython />,
  FaChartBar: <FaChartBar />,
};

const Certifications: React.FC = () => {
  const [certifications, setCertifications] = useState<Certification[]>([]);

  useEffect(() => {
    async function fetchCertifications() {
      const data = await getCertifications();
      setCertifications(data);
    }

    fetchCertifications();
  }, []);

  if (certifications.length === 0) {
    return (
      <div className="certifications-container" aria-busy="true" aria-live="polite">
        <h1 className="certifications-title">Certifications</h1>
        <p className="certifications-status">Loading certifications&hellip;</p>
      </div>
    );
  }

  return (
    <div className="certifications-container">
      <h1 className="certifications-title">Certifications</h1>
      <div className="certifications-grid">
        {certifications.map((cert, index) => (
          <a
            href={cert.link}
            key={cert.title}
            target="_blank"
            rel="noopener noreferrer"
            className="certification-card"
            style={{ '--delay': `${index * 0.08}s` } as React.CSSProperties}
          >
            <span className="certification-icon" aria-hidden="true">
              {iconMap[cert.iconName] || <FaUniversity />}
            </span>
            <span className="certification-body">
              <h2 className="certification-name">{cert.title}</h2>
              <span className="certification-issuer">{cert.issuer}</span>
              {cert.issuedDate && (
                <span className="issued-date">Issued {cert.issuedDate}</span>
              )}
              <span className="visually-hidden">(opens in a new tab)</span>
            </span>
            <span className="certification-link" aria-hidden="true">
              <FaExternalLinkAlt />
            </span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Certifications;
